import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import styles from "./filter.module.css";
import { industriesData } from "./industriesData";
import { MdCancel } from "react-icons/md";
import useStore from "../../../Store";
import {
  searchCompaniesById,
  searchCompanies,
  BusinessesforSalecardscreate,
  getMykohere,
  createRazorpayOrderContacts,
  checkIfCompanyPaid,
  searchExistBusinessForSale,
  handlePaymentSuccesscontacts,
  ContactcreditPricing,
} from "../../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import S3FileUpload from "react-s3";
import { config } from "./config";
import defaultIMG from "../../../Assets/defaultimg.png";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";

window.Buffer = window.Buffer || require("buffer").Buffer;

Modal.setAppElement("#root");

const CreateBusinessModal = ({
  showCreateForm,
  setShowCreateForm,
  handleInputChange,
  addNewBusiness,
}) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [companyData, setCompanyData] = useState(null);
  const [businesses, setBusinesses] = useState([]);

  // States and Cities
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  // New states for company search
  const [companies, setCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showCompanies, setShowCompanies] = useState(false);
  const [apiStatus, setApiStatus] = useState(null);
  const [companyName, setCompanyName] = useState();
  const documentInputRef = useRef();
  const imageInputRef = useRef();
  const searchInputRef = useRef();
  const { Theme } = useStore();
  const [errors, setErrors] = useState({});
  const [businessImages, setBusinessImages] = useState([]);
  const imagesInputRef = useRef();

  const navigate = useNavigate();
  const location = useLocation();

  // Payment and Verification States
  const [isVerified, setIsVerified] = useState(false);
  const [matchedCIN, setMatchedCIN] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("pay");
  const [salesCredits, setSalesCredits] = useState(0);
  const [pricingData, setPricingData] = useState([]);
  const [isCheckingAvailability, setIsCheckingAvailability] = useState(false);
  const [verificationMsg, setVerificationMsg] = useState({
    text: "",
    color: "",
  });

  const [newBusiness, setNewBusiness] = useState({
    CIN: "",
    operation_type: "",
    with_website: "",
    business_name: "",
    roc: "",
    authorised_capital: "",
    paid_up_capital: "",
    turn_over: "",
    pat: "",
    location: "",
    vintage_year: "",
    date_of_incorporation: "",
    document: null,
    business_image: null,
    about_company: "",
    email: "",
    phone: "",
    industry: "",
    legal_entity: "",
    sale_price: "",
    city: "",
    state: "",
    Registrant: "",
    linkedin: "",
    google: "",
  });

  useEffect(() => {
    const loadPricingAndCredits = async () => {
      try {
        const res = await ContactcreditPricing("sales");
        setPricingData(res.data?.salesPricing || []);
        const resp = await getMykohere();
        setSalesCredits(resp?.data?.user?.salesCredits || 0);
      } catch (error) {
        console.error("Error fetching pricing or credits:", error);
      }
    };
    if (showCreateForm) {
      loadPricingAndCredits();
      setErrors({});
    } else {
      setErrors({});
    }
  }, [showCreateForm]);

  // Fetch States
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}stateAndCities/getStates`,
        );
        const result = await response.json();
        if (result.success) {
          setStatesList(result.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  // Fetch Cities based on selected State
  useEffect(() => {
    const fetchCities = async () => {
      if (!newBusiness.state) {
        setCitiesList([]);
        return;
      }
      const selectedStateObj = statesList.find(
        (s) => s.name.toLowerCase() === newBusiness.state.toLowerCase(),
      );
      if (selectedStateObj) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}stateAndCities/getCitiesByState/${selectedStateObj.isoCode}`,
          );
          const result = await response.json();
          if (result.success) {
            setCitiesList(result.data);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      } else {
        setCitiesList([]);
      }
    };

    if (statesList.length > 0) {
      fetchCities();
    }
  }, [newBusiness.state, statesList]);

  const handleAvailabilityCheck = async (searchValue) => {
    if (!searchValue) return;
    setIsCheckingAvailability(true);
    setVerificationMsg({ text: "Checking availability...", color: "#666" });
    try {
      const params = /^[A-Z]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/.test(
        searchValue.toUpperCase(),
      )
        ? { CIN: searchValue, name: "" }
        : { name: searchValue, CIN: "" };

      const res = await searchExistBusinessForSale(params);
      if (res.data.status === 1) {
        setIsVerified(true);
        setMatchedCIN(res.data.CIN || searchValue);
        setVerificationMsg({ text: res.data.message, color: "green" });
      } else {
        setIsVerified(false);
        setMatchedCIN("");
        setVerificationMsg({ text: res.data.message, color: "red" });
      }
    } catch (error) {
      console.error("Search error:", error);
      setIsVerified(false);
      const errorMsg =
        error.response?.data?.message || "Error checking availability.";
      setVerificationMsg({ text: errorMsg, color: "red" });
    } finally {
      setIsCheckingAvailability(false);
    }
  };

  const validateFields = () => {
    const newErrors = {};

    const fieldLabels = {
      CIN: "CIN",
      business_name: "Business Name",
      sale_price: "Sale Price",
      email: "Email",
      phone: "Phone",
      city: "City",
      state: "State",
      about_company: "About Company",
      vintage_year: "Vintage Year",
      operation_type: "Operation Type",
      Registrant: "Registrant",
      legal_entity: "Legal Entity",
    };

    const requiredFields = Object.keys(fieldLabels);

    requiredFields.forEach((field) => {
      const value = newBusiness[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0)
      ) {
        newErrors[field] = `${fieldLabels[field]} is required.`;
      }
    });

    // Phone Number Format Validation
    if (!newErrors.phone) {
      const rawPhone = newBusiness.phone ? String(newBusiness.phone).trim() : "";
      let cleanPhone = rawPhone.replace(/[\s\-()]/g, "");
      if (cleanPhone.startsWith("+91")) {
        cleanPhone = cleanPhone.slice(3);
      } else if (cleanPhone.startsWith("91") && cleanPhone.length > 10) {
        cleanPhone = cleanPhone.slice(2);
      } else if (cleanPhone.startsWith("0") && cleanPhone.length > 10) {
        cleanPhone = cleanPhone.slice(1);
      }

      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(cleanPhone)) {
        newErrors.phone = "Please enter a valid 10-digit phone number.";
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstMissingField = Object.keys(newErrors)[0];
      const fieldElement = document.querySelector(
        `[name="${firstMissingField}"]`,
      );
      if (fieldElement) {
        fieldElement.focus();
      }
      return false;
    }

    return true;
  };

  // Company search function
  const searchCompanyHandler = async (searchValue = searchTerm) => {
    if (!searchValue.trim() || searchValue.length < 2) {
      setCompanies([]);
      setShowCompanies(false);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const queryKey = /^[A-Z]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/.test(
        searchValue.toUpperCase(),
      )
        ? "id"
        : "name";

      const response = await searchCompanies({ [queryKey]: searchValue });

      if (response.status === 200) {
        setApiStatus(response.data.Status);

        if (response.data.Status === 1) {
          setCompanies(response.data.companies || []);
          setShowCompanies(true);
        } else if (response.data.Status === 2) {
          const filteredCompanies =
            response.data.companies?.map((item) => ({
              cin: item.companyID,
              companyName: item.companyName,
            })) || [];
          setCompanies(filteredCompanies);
          setShowCompanies(true);
        } else {
          setCompanies([]);
          setShowCompanies(false);
        }
      } else {
        setCompanies([]);
        setError("No companies found");
        setShowCompanies(false);
      }
    } catch (err) {
      setError("Companies Not Found");
      console.error("Error searching companies:", err);
      setShowCompanies(false);
    } finally {
      setLoading(false);
    }
  };

  // Search by company name only
  // Handle company selection from dropdown
  const handleCompanySelect = async (selectedCompany) => {
    try {
      // CIN & Company Name
      const cinValue = selectedCompany.CIN || selectedCompany.cin || "";
      const companyName =
        selectedCompany.CompanyName || selectedCompany.companyName || "";

      setNewBusiness((prev) => ({
        ...prev,
        CIN: cinValue,
        business_name: companyName,
      }));

      setCompanyName(companyName);
      setShowCompanies(false);

      // Trigger availability check
      handleAvailabilityCheck(cinValue || companyName);

      // SuccessSwal("Fetching full company details...");

      // Fetch full details
      const response = await searchCompaniesById(cinValue, "your-auth-token");
      console.log(response);
      if (response?.data?.companyWithTopData) {
        const company = response.data.companyWithTopData;

        // Email handling (string or array)
        const emailValue = Array.isArray(company.EmailIds)
          ? company.EmailIds[0] || ""
          : company.EmailIds || "";
        console.log(company);
        setNewBusiness((prev) => ({
          ...prev,
          CIN: company.CIN || prev.CIN,
          google: company.WebsiteURL || "",
          business_name: company.CompanyName || prev.business_name,
          roc: company.Registrar_Of_Companies || "",
          authorised_capital: company.Authorized_Capital || "",
          paid_up_capital: company.PaidUp_Capital || "",
          turn_over: company.netRevenue || "",
          pat: company.profit_discontinuingOperations_afterTax || "",
          location:
            company.RegisteredOfficeAddress || company.Company_Address || "",
          date_of_incorporation: company.DateOfRegistration || "",
          vintage_year: company.vintageYear || "",
          // ✅ Prefill AboutCompany rich text
          about_company: company.AboutCompany || "",
          email: emailValue,
          phone: company.Phone || "",
          state: company.state || "",
        }));

        // SuccessSwal("Company details populated successfully!");
      } else {
        warningSwal("No detailed data found for this company.");
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
      warningSwal("Error fetching company details, please try again.");
    }
  };

  console.log(newBusiness);

  // Handle company selection from dropdown

  // Auto-search when typing (debounced)
  useEffect(() => {
    if (searchTerm.length >= 2) {
      const timeoutId = setTimeout(() => {
        searchCompanyHandler(searchTerm);
      }, 300);

      return () => clearTimeout(timeoutId);
    } else {
      setCompanies([]);
      setShowCompanies(false);
    }
  }, [searchTerm]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setShowCompanies(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Keep your original useEffect for CIN manual input
  //  useEffect(() => {
  //   if (newBusiness?.CIN && newBusiness.CIN.length > 15 && !searchTerm) {
  //     searchCompaniesById(newBusiness.CIN, "your-auth-token")
  //       .then((response) => {
  //         if (response?.data?.companyWithTopData) {
  //           const company = response.data.companyWithTopData;

  //           const emailValue = Array.isArray(company.EmailIds)
  //             ? company.EmailIds[0] || ""
  //             : company.EmailIds || "";
  // console.log("Company API full response:", company);

  //           setNewBusiness((prev) => ({
  //             ...prev,
  //             CIN: company.CIN || prev.CIN,
  //             business_name: company.CompanyName || "",
  //             roc: company.Registrar_Of_Companies || "",
  //             authorised_capital: company.Authorized_Capital || "",
  //             paid_up_capital: company.PaidUp_Capital || "",
  //             turn_over: company.netRevenue || "",
  //             pat: company.profit_discontinuingOperations_afterTax || "",
  //             location: company.RegisteredOfficeAddress || company.Company_Address || "",
  //             date_of_incorporation: company.DateOfRegistration || "",
  //             vintage_year: company.vintageYear || "",
  //             // ✅ Prefill AboutCompany rich text
  //             about_company: company.AboutCompany || "",
  //             email: emailValue,
  //             state: company.state || "",
  //           }));
  //         } else {
  //           warningSwal("Company data not found for the provided CIN.");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching company data:", error);
  //         warningSwal("Error fetching company data, please try again.");
  //       });
  //   }
  // }, [newBusiness.CIN, searchTerm]);

  const handleSubscribe = async (
    razorpay_order_id,
    razorpay_payment_id,
    credits,
    businessData,
  ) => {
    try {
      const data2 = {
        razorpay_order_id: razorpay_order_id,
        razorpay_payment_id: razorpay_payment_id,
        credits: credits,
      };

      const response = await handlePaymentSuccesscontacts(data2);

      if (response.status === 200) {
        const finalResponse = await BusinessesforSalecardscreate(businessData);
        if (finalResponse.status === 201 || finalResponse.status === 200) {
          SuccessSwal("Business Listing Created Successfully");
          addNewBusiness();
          setShowCreateForm(false);
        } else {
          warningSwal(finalResponse.message || "Something went wrong.");
        }
      } else {
        warningSwal(response.message || "Payment success callback failed.");
      }
    } catch (error) {
      console.error("Error in handleSubscribe:", error);
      warningSwal("An unexpected error occurred.");
    }
  };

  const handleCreateBusiness = async () => {
    const isValid = validateFields();
    if (!isValid) return;

    if (!isVerified) {
      warningSwal("Please verify company availability first.");
      return;
    }

    const industry = [
      selectedCategory,
      selectedSubcategory || "",
      selectedItem || "",
    ].filter((item) => item);

    let businessData = {
      ...newBusiness,
      industry: industry,
      operation_type: newBusiness.operation_type,
      with_website: newBusiness.with_website,
      Registrant: newBusiness.Registrant,
      state: newBusiness.state,
      city: newBusiness.city,
    };

    if (businessImages && businessImages.length > 0) {
      businessData.businessImages = businessImages;
    }
    if (newBusiness.vintage_year) {
      businessData.vintage_year = parseInt(newBusiness.vintage_year, 10);
    }
    if (newBusiness.with_website) {
      businessData.with_website = parseInt(newBusiness.with_website, 10);
    }
    if (!newBusiness.document) delete businessData.document;
    if (!newBusiness.business_image) delete businessData.business_image;

    try {
      if (paymentMethod === "credit") {
        const creditData = {
          companyId: matchedCIN || newBusiness.CIN,
          type: "sales",
        };
        const response = await checkIfCompanyPaid(creditData);
        if (response.status === 200) {
          const finalResponse =
            await BusinessesforSalecardscreate(businessData);
          if (finalResponse.status === 201 || finalResponse.status === 200) {
            SuccessSwal("Business Listing Created Successfully");
            addNewBusiness();
            setShowCreateForm(false);
          } else {
            warningSwal(finalResponse.message || "Failed to create business.");
          }
        } else {
          warningSwal(response.message || "Failed to process credits.");
        }
      } else {
        const pricingItem = pricingData?.find((item) => item.minCredits == 1);
        const totalPrice = Number(pricingItem?.pricePerCredit || 0) * 1.18;
        const roundedAmount = parseFloat(totalPrice.toFixed(2));

        const orderRes = await createRazorpayOrderContacts({
          amount: roundedAmount,
          type: "sales",
        });

        if (orderRes.status === 201) {
          const options = {
            key: process.env.REACT_APP_RAZORPAYKEY_TEST,
            amount: roundedAmount * 100,
            currency: "INR",
            name: "Kohere",
            description: "Business Listing Payment",
            order_id: orderRes.data.data.razorpay_orderId,
            handler: (response) => {
              if (response.razorpay_payment_id) {
                handleSubscribe(
                  orderRes.data.data.razorpay_orderId,
                  response.razorpay_payment_id,
                  1,
                  businessData,
                );
              } else {
                warningSwal("Payment failed or cancelled.");
              }
            },
            prefill: { name: "Kohere User", email: "user@kohere.in" },
            theme: { color: "#3B82F6" },
          };
          const rzp1 = new window.Razorpay(options);
          rzp1.open();
        } else {
          warningSwal("Failed to create Razorpay order.");
        }
      }
    } catch (err) {
      console.error("Submission error:", err);
      warningSwal("Request failed. Please try again.");
    }
  };

  useEffect(() => {
    if (showCreateForm) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showCreateForm]);

  if (!showCreateForm) {
    return null;
  }

  const fileUploadHandler = (event, type) => {
    // Multi-image upload
    if (type === "images") {
      const files = Array.from(event.target.files || []);
      if (files.length === 0) return;

      const validImageTypes = ["image/png", "image/jpg", "image/jpeg"];

      files.forEach((file) => {
        if (!validImageTypes.includes(file.type)) {
          warningSwal(
            `Please upload a valid image file (PNG, JPG, JPEG): ${file.name}`,
          );
          return;
        }

        const fileExtension = file.name.split(".").pop();
        const filename = `${new Date().getTime()}_${file.name.replace(/\s+/g, "_")}`;
        const newFile = new File([file], filename);

        S3FileUpload.uploadFile(newFile, config)
          .then((data) => {
            const fullUrl = data.location; // full S3 URL
            setBusinessImages((prev) => [
              ...prev,
              { name: file.name, image: fullUrl },
            ]);
          })
          .catch((err) => {
            console.error("Error uploading image:", err);
            warningSwal("Error uploading one of the images. Please try again.");
          });
      });

      return;
    }

    // Single image or document handling (existing behavior)
    const file = event.target.files?.[0];
    if (!file) return;

    const fileType = file.type;
    const fileExtension = file.name.split(".").pop();
    const filename = `${new Date().getTime()}.${fileExtension}`;
    const newFile = new File([file], filename);

    if (type === "image") {
      const validImageTypes = ["image/png", "image/jpg", "image/jpeg"];
      if (!validImageTypes.includes(fileType)) {
        warningSwal("Please upload a valid image file (PNG, JPG, JPEG).");
        return;
      }

      S3FileUpload.uploadFile(newFile, config)
        .then((data) => {
          const modifiedFile = data.location.split("/").pop();
          setNewBusiness((prev) => ({
            ...prev,
            business_image: modifiedFile,
          }));
        })
        .catch((err) => {
          console.error("Error uploading image:", err);
          warningSwal("Error uploading the image. Please try again.");
        });
    } else if (type === "document") {
      const validDocumentTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (!validDocumentTypes.includes(fileType)) {
        warningSwal("Please upload a valid document (PDF, Word).");
        return;
      }

      S3FileUpload.uploadFile(newFile, config)
        .then((data) => {
          const modifiedFile = data.location.split("/").pop();
          setNewBusiness((prev) => ({
            ...prev,
            document: modifiedFile,
            documentType: "document",
          }));
        })
        .catch((err) => {
          console.error("Error uploading document:", err);
          warningSwal("Error uploading the document. Please try again.");
        });
    }
  };

  const updateImageName = (index, value) => {
    setBusinessImages((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], name: value };
      return copy;
    });
  };

  const removeImage = (index) => {
    setBusinessImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    setSelectedSubcategory("");
    setSelectedItem("");
    handleInputChange(e);
  };

  const handleSubcategoryChange = (e) => {
    const subcategory = e.target.value;
    setSelectedSubcategory(subcategory);
    setSelectedItem("");
    handleInputChange(e);
  };

  const handleItemChange = (e) => {
    const item = e.target.value;
    setSelectedItem(item);
    handleInputChange(e);
  };

  const getSubcategoriesForCategory = (categoryName) => {
    const category = industriesData.find(
      (cat) => cat.category === categoryName,
    );
    return category ? category.subcategories : [];
  };

  const getItemsForSubcategory = (subcategoryName) => {
    const category = industriesData.find(
      (cat) => cat.category === selectedCategory,
    );
    const subcategory = category?.subcategories.find(
      (sub) => sub.name === subcategoryName,
    );
    return subcategory ? subcategory.items : [];
  };

  return (
    <Modal
      isOpen={showCreateForm}
      onRequestClose={() => setShowCreateForm(false)}
      contentLabel="Create Business for Sale"
      className={`${styles.modalContent} ${Theme !== "default" ? "green" : ""}`}
      overlayClassName={styles.modalOverlay}
    >
      <div className={styles.modalHeader}>
        <div>
          <h2>Create a New Business for Sale</h2>
          <p>
            Enter business details and complete verification to list your
            company
          </p>
        </div>
        <button
          className={styles.closeBtn}
          onClick={() => setShowCreateForm(false)}
        >
          &times;
        </button>
      </div>

      <div className={styles.modalBody}>
        {/* Section 1: Company Verification */}
        <h4 className={styles.sectionTitle}>Company Verification</h4>
        <div className={styles.formGroup} ref={searchInputRef}>
          <label htmlFor="company_search">
            Search Company (by Name or CIN) *
          </label>
          <div style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Type at least 2 characters to search companies..."
              value={companyName}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCompanyName(e.target.value);
              }}
            />
            {loading && (
              <div
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                Searching...
              </div>
            )}

            {/* Company Dropdown - Simplified and styled inline for positioning */}
            {showCompanies && companies.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  maxHeight: "250px",
                  overflowY: "auto",
                  zIndex: 1010,
                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                  marginTop: "4px",
                }}
              >
                {companies.map((company, index) => (
                  <div
                    key={index}
                    onClick={() => handleCompanySelect(company)}
                    style={{
                      padding: "12px 16px",
                      borderBottom:
                        index < companies.length - 1
                          ? "1px solid #f1f5f9"
                          : "none",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8fafc")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#1e293b",
                        fontSize: "14px",
                      }}
                    >
                      {company.CompanyName}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#64748b",
                        marginTop: "2px",
                      }}
                    >
                      CIN: {company.CIN} {company.state && `| ${company.state}`}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="CIN">CIN *</label>
            <input
              type="text"
              name="CIN"
              placeholder="Corporate Identification Number"
              value={newBusiness.CIN}
              readOnly
              className={errors.CIN ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  CIN: e.target.value,
                });
                if (errors.CIN) setErrors((prev) => ({ ...prev, CIN: "" }));
              }}
            />
            {errors.CIN && (
              <span className={styles.errorMessage}>{errors.CIN}</span>
            )}
            {verificationMsg.text && (
              <p
                style={{
                  fontSize: "12px",
                  color: verificationMsg.color,
                  marginTop: "4px",
                  fontWeight: "600",
                }}
              >
                {verificationMsg.text}
              </p>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="business_name">Business Name *</label>
            <input
              name="business_name"
              placeholder="Business Legal Name"
              value={newBusiness.business_name}
              className={errors.business_name ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  business_name: e.target.value,
                });
                if (errors.business_name) setErrors((prev) => ({ ...prev, business_name: "" }));
              }}
            />
            {errors.business_name && (
              <span className={styles.errorMessage}>{errors.business_name}</span>
            )}
          </div>
        </div>

        {/* Section 2: Basic Information */}
        <h4 className={styles.sectionTitle}>Basic Information</h4>
        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="legal_entity">Legal Entity *</label>
            <select
              name="legal_entity"
              value={newBusiness.legal_entity}
              className={errors.legal_entity ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  legal_entity: e.target.value,
                });
                if (errors.legal_entity) setErrors((prev) => ({ ...prev, legal_entity: "" }));
              }}
            >
              <option value="">Select Entity Type</option>
              <option value="Private Limited Company">
                Private Limited Company
              </option>
              <option value="Public Limited Company">
                Public Limited Company
              </option>
              <option value="Limited Liability Partnership">
                Limited Liability Partnership
              </option>
              <option value="One Person Company">One Person Company</option>
              <option value="Proprietorship">Proprietorship</option>
            </select>
            {errors.legal_entity && (
              <span className={styles.errorMessage}>{errors.legal_entity}</span>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="date_of_incorporation">Date of Incorporation</label>
            <input
              type="text"
              name="date_of_incorporation"
              placeholder="DD-MM-YYYY"
              value={newBusiness.date_of_incorporation}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  date_of_incorporation: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="vintage_year">Vintage Year *</label>
            <input
              type="number"
              name="vintage_year"
              placeholder="e.g. 2015"
              value={newBusiness.vintage_year}
              className={errors.vintage_year ? styles.errorInput : ""}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  vintage_year: e.target.value,
                });
                if (errors.vintage_year) setErrors((prev) => ({ ...prev, vintage_year: "" }));
              }}
            />
            {errors.vintage_year && (
              <span className={styles.errorMessage}>{errors.vintage_year}</span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="roc">Registrar of Companies (ROC)</label>
            <input
              type="text"
              name="roc"
              placeholder="e.g. ROC Mumbai"
              value={newBusiness.roc}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  roc: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Official Email *</label>
            <input
              type="email"
              name="email"
              placeholder="contact@company.com"
              value={newBusiness.email}
              className={errors.email ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  email: e.target.value,
                });
                if (errors.email) setErrors((prev) => ({ ...prev, email: "" }));
              }}
            />
            {errors.email && (
              <span className={styles.errorMessage}>{errors.email}</span>
            )}
          </div>
          {/* phone */}
          <div className={styles.formGroup}>
            <label htmlFor="phone">Phone *</label>
            <input
              type="text"
              name="phone"
              placeholder="Enter phone number"
              value={newBusiness.phone}
              className={errors.phone ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  phone: e.target.value,
                });
                if (errors.phone) setErrors((prev) => ({ ...prev, phone: "" }));
              }}
            />
            {errors.phone && (
              <span className={styles.errorMessage}>{errors.phone}</span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="sale_price">Asking Sale Price (₹) *</label>
            <input
              type="number"
              name="sale_price"
              placeholder="Enter asking price"
              value={newBusiness.sale_price}
              className={errors.sale_price ? styles.errorInput : ""}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  sale_price: e.target.value,
                });
                if (errors.sale_price) setErrors((prev) => ({ ...prev, sale_price: "" }));
              }}
            />
            {errors.sale_price && (
              <span className={styles.errorMessage}>{errors.sale_price}</span>
            )}
          </div>
        </div>

        {/* Section 3: Industry Details */}
        <h4 className={styles.sectionTitle}>Industry & Sector</h4>
        <div className={styles.formGroup}>
          <label>Industry Category</label>
          <select value={selectedCategory} onChange={handleCategoryChange}>
            <option value="">Select Industry</option>
            {industriesData.map((cat, index) => (
              <option key={index} value={cat.category}>
                {cat.category}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label>Subcategory</label>
            <select
              value={selectedSubcategory}
              onChange={handleSubcategoryChange}
              disabled={!selectedCategory}
            >
              <option value="">Select Subcategory</option>
              {getSubcategoriesForCategory(selectedCategory).map(
                (sub, index) => (
                  <option key={index} value={sub.name}>
                    {sub.name}
                  </option>
                ),
              )}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label>Segment / Item</label>
            <select
              value={selectedItem}
              onChange={handleItemChange}
              disabled={!selectedSubcategory}
            >
              <option value="">Select Item</option>
              {getItemsForSubcategory(selectedSubcategory).map(
                (item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ),
              )}
            </select>
          </div>
        </div>

        {/* Section 4: Financials */}
        <h4 className={styles.sectionTitle}>Financial Summary</h4>
        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="authorised_capital">Authorised Capital (₹)</label>
            <input
              type="number"
              name="authorised_capital"
              placeholder="e.g. 1000000"
              value={newBusiness.authorised_capital}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  authorised_capital: e.target.value,
                })
              }
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="paid_up_capital">Paid-up Capital (₹)</label>
            <input
              type="number"
              name="paid_up_capital"
              placeholder="e.g. 500000"
              value={newBusiness.paid_up_capital}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  paid_up_capital: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="turn_over">Annual Turnover (₹)</label>
            <input
              type="number"
              name="turn_over"
              placeholder="Turnover"
              value={newBusiness.turn_over}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  turn_over: e.target.value,
                })
              }
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="pat">PAT (Profit After Tax) (₹)</label>
            <input
              type="number"
              name="pat"
              placeholder="PAT"
              value={newBusiness.pat}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  pat: e.target.value,
                })
              }
            />
          </div>
        </div>

        {/* Section 5: About & Description */}
        <h4 className={styles.sectionTitle}>Business Description</h4>
        <div className={styles.formGroup}>
          <label htmlFor="about_company">Describe your Business *</label>
          <ReactQuill
            theme="snow"
            value={newBusiness.about_company}
            onChange={(content) => {
              setNewBusiness((prev) => ({
                ...prev,
                about_company: content,
              }));
              if (errors.about_company) setErrors((prev) => ({ ...prev, about_company: "" }));
            }}
            placeholder="Write a few lines about your company operations, USP, etc."
            style={{
              borderRadius: "12px",
              background: "#fff",
              border: errors.about_company ? "1px solid #ef4444" : "",
            }}
          />
          {errors.about_company && (
            <span className={styles.errorMessage}>{errors.about_company}</span>
          )}
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="state">State *</label>
            <Select
              name="state"
              options={statesList.map((stateItem) => ({
                value: stateItem.name,
                label: stateItem.name,
              }))}
              value={
                newBusiness.state
                  ? { value: newBusiness.state, label: newBusiness.state }
                  : null
              }
              onChange={(selectedOption) => {
                setNewBusiness({
                  ...newBusiness,
                  state: selectedOption ? selectedOption.value : "",
                  city: "", // Reset city when state changes
                });
                if (errors.state) setErrors((prev) => ({ ...prev, state: "" }));
              }}
              placeholder="Select State"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: errors.state ? "#ef4444" : "#e2e8f0",
                  padding: "2px",
                  boxShadow: errors.state ? "0 0 0 1px #ef4444" : "none",
                  "&:hover": {
                    borderColor: errors.state ? "#ef4444" : "#cbd5e1",
                  },
                }),
              }}
            />
            {errors.state && (
              <span className={styles.errorMessage}>{errors.state}</span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="city">City *</label>
            <Select
              name="city"
              options={citiesList.map((cityItem) => ({
                value: cityItem.name,
                label: cityItem.name,
              }))}
              value={
                newBusiness.city
                  ? { value: newBusiness.city, label: newBusiness.city }
                  : null
              }
              onChange={(selectedOption) => {
                setNewBusiness({
                  ...newBusiness,
                  city: selectedOption ? selectedOption.value : "",
                });
                if (errors.city) setErrors((prev) => ({ ...prev, city: "" }));
              }}
              placeholder="Select City"
              isDisabled={!newBusiness.state || citiesList.length === 0}
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  borderColor: errors.city ? "#ef4444" : "#e2e8f0",
                  padding: "2px",
                  boxShadow: errors.city ? "0 0 0 1px #ef4444" : "none",
                  "&:hover": {
                    borderColor: errors.city ? "#ef4444" : "#cbd5e1",
                  },
                }),
              }}
            />
            {errors.city && (
              <span className={styles.errorMessage}>{errors.city}</span>
            )}
          </div>
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="location">Registered Address</label>
          <textarea
            name="location"
            placeholder="Full registered office address"
            value={newBusiness.location}
            onChange={(e) =>
              setNewBusiness({
                ...newBusiness,
                location: e.target.value,
              })
            }
          />
        </div>

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="operation_type">Operation Type *</label>
            <select
              name="operation_type"
              value={newBusiness.operation_type}
              className={errors.operation_type ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  operation_type: e.target.value,
                });
                if (errors.operation_type) setErrors((prev) => ({ ...prev, operation_type: "" }));
              }}
            >
              <option value="">Select Operation Type</option>
              <option value="Manufacturing">Manufacturing</option>
              <option value="Services">Services</option>
              <option value="Retail">Retail</option>
              <option value="Trading">Trading</option>
            </select>
            {errors.operation_type && (
              <span className={styles.errorMessage}>{errors.operation_type}</span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="with_website">Presence Online</label>
            <select
              name="with_website"
              value={newBusiness.with_website}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  with_website: e.target.value,
                })
              }
            >
              <option value="">Select Website Option</option>
              <option value="1">With Website</option>
              <option value="0">Without Website</option>
            </select>
          </div>
        </div>

        {newBusiness.with_website === "1" && (
          <div className={styles.formGroup}>
            <label htmlFor="google">Website URL</label>
            <input
              type="text"
              name="google"
              placeholder="https://example.com"
              value={newBusiness.google}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  google: e.target.value,
                })
              }
            />
          </div>
        )}

        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label htmlFor="Registrant">Registrant Role *</label>
            <select
              name="Registrant"
              value={newBusiness.Registrant}
              className={errors.Registrant ? styles.errorInput : ""}
              onChange={(e) => {
                setNewBusiness({
                  ...newBusiness,
                  Registrant: e.target.value,
                });
                if (errors.Registrant) setErrors((prev) => ({ ...prev, Registrant: "" }));
              }}
            >
              <option value="">Select Registrant Role</option>
              <option value="Director">Director</option>
              <option value="Founder">Founder</option>
              <option value="Associate">Associate</option>
              <option value="Broker/Advisor">Broker/Advisor</option>
            </select>
            {errors.Registrant && (
              <span className={styles.errorMessage}>{errors.Registrant}</span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="linkedin">LinkedIn URL</label>
            <input
              type="text"
              name="linkedin"
              placeholder="Profile URL"
              value={newBusiness.linkedin}
              onChange={(e) =>
                setNewBusiness({
                  ...newBusiness,
                  linkedin: e.target.value,
                })
              }
            />
          </div>
        </div>

        {/* Section 6: Media & Assets */}
        <h4 className={styles.sectionTitle}>Images & Documents</h4>
        <div className={styles.formRow}>
          <div className={styles.formGroup}>
            <label>Business Main Image</label>
            <input
              type="file"
              onChange={(e) => fileUploadHandler(e, "image")}
            />
            {newBusiness.business_image && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "8px",
                }}
              >
                <img
                  src={`https://${process.env.REACT_APP_BUCKETNAME}.s3.ap-south-1.amazonaws.com/${newBusiness.business_image}`}
                  alt="Preview"
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <span style={{ fontSize: "12px", color: "#64748b" }}>
                  Primary Image Uploaded
                </span>
              </div>
            )}
          </div>
          <div className={styles.formGroup}>
            <label>Relevant Document (PDF/Word)</label>
            <input
              type="file"
              onChange={(e) => fileUploadHandler(e, "document")}
            />
            {newBusiness.document && (
              <p
                style={{ fontSize: "12px", color: "#10b981", marginTop: "8px" }}
              >
                document_uploaded.{newBusiness.document.split(".").pop()}
              </p>
            )}
          </div>
        </div>

        <div className={styles.formGroup}>
          <label>Additional Business Photos</label>
          <input
            type="file"
            multiple
            onChange={(e) => fileUploadHandler(e, "images")}
          />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
              gap: "12px",
              marginTop: "16px",
            }}
          >
            {businessImages.map((img, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  border: "1px solid #e2e8f0",
                  padding: "8px",
                  borderRadius: "12px",
                  background: "#f8fafc",
                }}
              >
                <img
                  src={img.image}
                  style={{
                    width: "100%",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                  alt={`Preview ${index}`}
                />
                <input
                  type="text"
                  value={img.name}
                  onChange={(e) => updateImageName(index, e.target.value)}
                  placeholder="Image Caption"
                  style={{
                    fontSize: "11px",
                    height: "auto",
                    padding: "4px",
                    marginTop: "4px",
                    border: "none",
                    background: "transparent",
                  }}
                />
                <button
                  onClick={() => removeImage(index)}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    background: "#ef4444",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    fontSize: "12px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.paymentSection}>
          <h4
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: "700",
              color: "#0f172a",
            }}
          >
            Select Payment Method
          </h4>
          <p style={{ fontSize: "13px", color: "#64748b", marginTop: "4px" }}>
            Verification fee: 1 Credit or ₹
            {pricingData?.find((item) => item.minCredits == 1)?.pricePerCredit
              ? Number(
                  pricingData.find((item) => item.minCredits == 1)
                    .pricePerCredit,
                ).toFixed(2)
              : "—"}{" "}
          </p>

          <div className={styles.paymentOptions}>
            {/* <div
                            className={`${styles.paymentOption} ${paymentMethod === "pay" ? styles.active : ""}`}
                            onClick={() => setPaymentMethod("pay")}
                        >
                            <span className={styles.paymentOptionTitle}>Razorpay (Pay ₹)</span>
                            <span className={styles.paymentOptionDesc}>
                                Pay ₹{((pricingData?.find((i) => i.minCredits == 1)?.pricePerCredit || 450) * 1.18).toFixed(2)} using UPI/Card
                            </span>
                        </div> */}
            <div
              className={`${styles.paymentOption} ${paymentMethod === "credit" ? styles.active : ""} ${salesCredits <= 0 ? styles.disabled : ""}`}
              onClick={() => salesCredits > 0 && setPaymentMethod("credit")}
              style={{
                opacity: salesCredits <= 0 ? 0.6 : 1,
                cursor: salesCredits <= 0 ? "not-allowed" : "pointer",
              }}
            >
              <span className={styles.paymentOptionTitle}>Use Credits</span>
              <span className={styles.paymentOptionDesc}>
                {salesCredits <= 0
                  ? "No Credits Available"
                  : `1 Credit from wallet. Balance: ${salesCredits}`}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.modalFooter}>
        <button
          className={styles.secondaryBtn}
          onClick={() => setShowCreateForm(false)}
        >
          Cancel
        </button>
        <button
          className={styles.primaryBtn}
          onClick={handleCreateBusiness}
          disabled={isCheckingAvailability}
        >
          {isCheckingAvailability ? "Verifying..." : "Pay & Create Listing"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateBusinessModal;
